<template>
  <div class="sd-announcement">
    <div class="sd-anncmt-box" v-if="announcement">
      <div id="sd-anncmt-header">
        <a class="sd-anncmt-close" @click="$emit('close')">
          <span>schliessen</span>
          <img src="/static/material_icons/close.png"
            width="14px" height="14px"
          />
        </a>
      </div>
      <div class="sd-anncmt-scrollable">
        <div class="sd-anncmt-content"
          v-html="announcement"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixins/Mixins';

export default {
  name: 'sd-announcement',
  mixins: [mixin],

  data() {
    return {
      announcement: this.announcement,
    };
  },

  computed: {
    routeKey() {
      if ('key' in this.$route.params) {
        return this.$route.params.key.toLowerCase();
      }
      return undefined;
    },
  },

  mounted() {
    this.queryAnnouncement(this.routeKey);
  },
};
</script>

<style lang="scss">
@import "./../../Globals.scss";

.sd-announcement {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background-color: $sd-color-lightgrey-05;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;

  .sd-anncmt-box {
    background: white;
    max-width: $sd-max-width;
    max-height: 500px;
    padding: 15px 0 40px 0;
    text-align: left;
    box-shadow: $sd-box-shadow;
    position: relative;
  }

  #sd-anncmt-header {
    display: flex;
    width: 100%;
    background: #ffffff;
    padding-bottom: 30px;

    a {
      position: absolute;
      right: 0px;
      padding-right: 20px;
      cursor: pointer;
      font-size: 14px;
      font-weight: bold;
      color: #61849c;
      display: table;

      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }

      img {
        vertical-align: middle;
        display: table-cell;
        border-radius: 50px;
        padding: 0.3em 0.3em;
      }
      span {
        vertical-align: middle;
        display: table-cell;
        padding: 0 5px 0 5px;
      }
    }
  }

  .sd-anncmt-scrollable {
    max-height: 500px;
    overflow-y: scroll;
    margin: 0 20px 0 20px;

    .sd-anncmt-content:after {
      content: "";
      position: absolute;
      z-index: 1;
      bottom: 0;
      left: 0;
      pointer-events: none;
      background-image: linear-gradient(
        to bottom, rgba(255,255,255,0), rgba(255,255,255, 1) 90%);
      width: 100%;
      height: 4em;

      a {
        color: $sd-color-blue;
      }
    }
  }
}

@media (max-width: 720px) {
  .sd-announcement {
    .sd-anncmt-header {
      font-size: 11px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Announcement.vue?9e7f7bcc